const config = {
     API_BASE_URL: 'https://permits.unifyitc.net',
     // API_BASE_URL: 'http://localhost:5000',
     // API_BASE_URL: 'https://documents.jstvistara.com',
     SECRET_KEY : "hJ7xP0sA92mX4UeN8bQ1cV5wT9zL2RkF" 
};

export default config;
